import React, { FC } from "react";
import memoize from "utils/memoize";
import {
  RHFormConsumerTextField,
  RHFormConsumerTextFieldProps
} from "component-rh-text-field/RHFormConsumerTextField";
import { phoneRegex } from "utils/regex";

export const PhoneField: FC<RHFormConsumerTextFieldProps> = ({ ...props }) => (
  <RHFormConsumerTextField
    defaultValue=""
    autoComplete="tel"
    rules={{
      required: props.required
        ? props.errorMessages?.["phoneRequired"] || "Phone required."
        : null,
      pattern: {
        value: phoneRegex,
        message: props.errorMessages?.["invalidPhone"] || "Invalid Phone."
      }
    }}
    name={"phone"}
    fullWidth
    label={props.label || "Phone"}
    {...props}
  />
);

export default memoize(PhoneField);
